import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import StepNavigation from "./StepNavigation";
import "../../styles/steps.css";

const CONDITIONS = [
  "black_frame",
  "white_frame",
  "green_frame",
];

const RENOVATIONS = [
  "renovation_new",
  "renovation_old",
  "renovation_in_process",
];

export default function StepCondition({
  listing,
  setListing,
  onBack,
  onNext,
}) {
  const { t } = useTranslation();

   return (
    <div className="step">
      <h2 className="step-title">{t("baseline_condition")}</h2>

      {/* CONDITION */}
      <div className="option-grid">
        {CONDITIONS.map((c) => (
          <button
            key={c}
            type="button"
            className={`option-card ${
              listing.condition === c ? "active primary" : ""
            }`}
            onClick={() =>
              setListing((l) => ({
                ...l,
                condition: c,
              }))
            }
          >
            {t(c)}
          </button>
        ))}
      </div>

      {/* 🟢 RENOVATION (ONLY FOR GREEN FRAME) */}
      {listing.condition && (
        <>
          <h3 className="step-subtitle">
  {t("renovation_type")}
  {listing.condition === "green_frame" && (
    <span className="required">*</span>
  )}
</h3>

          <div className="option-grid small">
            {RENOVATIONS.map((r) => (
              <button
                key={r}
                type="button"
                className={`option-card ${
                  listing.renovation === r ? "active success" : ""
                }`}
                onClick={() =>
                  setListing((l) => ({
                    ...l,
                    renovation: r,
                  }))
                }
              >
                {t(r)}
              </button>
            ))}
          </div>
        </>
      )}

      <StepNavigation
        onBack={onBack}
        onNext={onNext}
        nextDisabled={
          !listing.condition ||
          (listing.condition === "green_frame" && !listing.renovation)
        }
      />
    </div>
  );
}
